import request from '@/request/request'

/**
 * 获取公开招租列表
 * @param {} parameter 
 * @returns 
 */
export function listApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/listApplyProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除公开招租信息
 * @param {} parameter 
 * @returns 
 */
export function deleteApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/deleteApplyProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 获取意向发布列表
 * @param {} parameter 
 * @returns 
 */
export function listIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/listIntentProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除意向发布信息
 * @param {} parameter 
 * @returns 
 */
export function deleteIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/deleteIntentProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 房源信息选择权证详情
 * @param {} parameter 
 * @returns 
 */
export function listWarrantByHouseWebId (parameter) {
  return request({
    url: '/e-find-property/housingResources/listWarrantByHouseWebId',
    method: 'post',
    data: parameter
  })
}

/**
 * 房源信息选择权证详情
 * @param {} parameter 
 * @returns 
 */
export function listSelectHouseDetail (parameter) {
  return request({
    url: '/e-find-property/housingResources/listSelectHouseDetail',
    method: 'post',
    data: parameter
  })
}

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function saveBidApply (parameter) {
  return request({
    url: '/e-find-property/bidApply/saveBidApply',
    method: 'post',
    data: parameter
  })
}
